"use strict";
// DO NOT EDIT THIS FILE, EDIT THE GRUNT TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
angular.module('mediacloudApp')

.constant('ENV', 'prod')

.constant('VERSION', '0.0.1-SNAPSHOT')

;